// Bilingual translations for static UI (EN / TA)
export const translations = {
    en: {
        siteName: "District Industries Centre",
        siteSubtitle: "Government of Tamil Nadu",
        nav: {
            home: "Home",
            department: "Department",
            structure: "Office Structure",
            role: "Role of DIC",
            schemes: "Schemes",
            contact: "Contact",
            adminLogin: "Admin Login",
            logout: "Logout",
        },
        home: {
            eyebrow: "Government of Tamil Nadu · Since 1978",
            heroTitle: "Empowering Every Entrepreneur Across Tamil Nadu",
            heroSubtitle:
                "The District Industries Centre is your single-window gateway to Government schemes, credit-linked subsidies, training and mentorship for micro, small and medium enterprises.",
            ctaSchemes: "Explore Schemes",
            ctaContact: "Get Assistance",
            statsTitle: "Impact At A Glance",
            statSchemes: "Government Schemes",
            statDistricts: "Districts Served",
            statBeneficiaries: "Lakh Beneficiaries",
            statYears: "Years of Service",
            missionEyebrow: "Our Mission",
            missionTitle: "Bringing Industrial Opportunity to Every District",
            missionBody:
                "DIC acts as the extended arm of the Commissionerate of Industries & Commerce, translating State and Central industrial policy into ground-level enterprise creation. From an artisan in Kanchipuram to a food processing unit in Erode — every entrepreneur has a partner here.",
            featuredEyebrow: "Featured Programmes",
            featuredTitle: "Flagship Schemes",
            featuredSub: "Curated schemes with highest impact for aspiring entrepreneurs",
            viewAll: "View all schemes",
        },
        department: {
            eyebrow: "About the Department",
            title: "District Industries Centre, Tamil Nadu",
            intro:
                "Established in 1978 under a Government of India initiative, District Industries Centres (DICs) were created to provide services and support facilities to entrepreneurs in setting up MSMEs at the district level.",
            visionTitle: "Our Vision",
            visionBody:
                "To make Tamil Nadu the most preferred destination for micro, small and medium enterprises through an efficient, transparent and entrepreneur-first ecosystem.",
            missionTitle: "Our Mission",
            missionBody:
                "Facilitate identification of suitable projects, credit facilitation, subsidy administration, cluster development, technical guidance, and marketing support to entrepreneurs across all 38 districts.",
            objectivesTitle: "Key Objectives",
            objectives: [
                "Promote balanced regional industrial development across Tamil Nadu",
                "Identify and mentor first-generation entrepreneurs, especially women & SC/ST",
                "Administer credit-linked subsidy schemes of Union & State Governments",
                "Facilitate skill development, EDP training and technology upgradation",
                "Build MSME clusters, industrial estates and shared infrastructure",
                "Serve as single-window liaison with banks, PSUs and departments",
            ],
        },
        structure: {
            eyebrow: "Office Structure",
            title: "Organisational Hierarchy",
            subtitle:
                "Every DIC in Tamil Nadu operates under the Commissionerate of Industries & Commerce and is led by a General Manager.",
            roles: {
                commissioner: "Commissioner of Industries & Commerce",
                director: "Director of Industries & Commerce",
                gm: "General Manager (DIC)",
                mgr: "Manager",
                amgr: "Assistant Manager",
                io: "Industries Officer / Field Officer",
                ta: "Technical & Ministerial Staff",
            },
        },
        role: {
            eyebrow: "Role of DIC",
            title: "What District Industries Centres Do",
            subtitle:
                "A full-stack support ecosystem — from idea to industrial estate allotment.",
            functionsTitle: "Core Functions",
            servicesTitle: "Services Offered to Entrepreneurs",
        },
        schemes: {
            eyebrow: "Government Schemes",
            title: "Discover the Right Scheme For You",
            subtitle:
                "Curated Central & State government schemes administered through District Industries Centres.",
            searchPlaceholder: "Search by scheme name, keyword…",
            filterAll: "All Categories",
            categories: {
                MSME: "MSME",
                Women: "Women",
                SC_ST: "SC / ST",
                Youth: "Youth",
                Agri: "Agri",
                General: "General",
            },
            noResults: "No schemes match your filters.",
            viewDetails: "View Details",
            downloadForm: "Download Form (PDF)",
            eligibility: "Eligibility",
            benefits: "Benefits",
            process: "Application Process",
            back: "Back to Schemes",
            featured: "Featured",
        },
        contact: {
            eyebrow: "Contact Us",
            title: "Reach Your District Industries Centre",
            subtitle:
                "Have a question about a scheme or need help starting your enterprise? Send us an enquiry — a District Industries Officer will get in touch within 3 working days.",
            name: "Full Name",
            email: "Email Address",
            phone: "Phone Number",
            district: "District",
            subject: "Subject",
            message: "Your Message",
            submit: "Submit Enquiry",
            submitting: "Submitting…",
            success: "Enquiry submitted. Our officer will contact you soon.",
            error: "Something went wrong. Please try again.",
            hqTitle: "Head Office",
            hqAddress:
                "Commissionerate of Industries & Commerce, Guindy Industrial Estate, Chennai — 600 032, Tamil Nadu",
            hqPhone: "+91 44 2250 0651",
            hqEmail: "commissioner.dic@tn.gov.in",
            hours: "Mon – Fri · 10:00 – 17:45 (except public holidays)",
        },
        admin: {
            loginTitle: "Administrator Sign In",
            loginSub: "Access the DIC content management console.",
            email: "Email",
            password: "Password",
            signIn: "Sign In",
            signingIn: "Signing in…",
            loginFailed: "Invalid credentials.",
            dashTitle: "Admin Dashboard",
            welcome: "Welcome",
            tabSchemes: "Manage Schemes",
            tabEnquiries: "Enquiries",
            newScheme: "New Scheme",
            editScheme: "Edit Scheme",
            deleteScheme: "Delete",
            save: "Save",
            saving: "Saving…",
            cancel: "Cancel",
            confirmDelete: "Delete this scheme? This cannot be undone.",
            markHandled: "Mark handled",
            markNew: "Mark new",
            deleteEnquiry: "Delete",
            statusNew: "New",
            statusHandled: "Handled",
            noEnquiries: "No enquiries yet.",
        },
        footer: {
            about:
                "District Industries Centre is the extended arm of the Commissionerate of Industries & Commerce, Government of Tamil Nadu, catalysing MSME growth across all 38 districts.",
            quickLinks: "Quick Links",
            contact: "Contact",
            copyright: "© {year} District Industries Centre, Government of Tamil Nadu. All rights reserved.",
            disclaimer:
                "This is a demonstration portal built as a sample project. Content is illustrative and not an official Government of Tamil Nadu publication.",
        },
    },
    ta: {
        siteName: "மாவட்ட தொழில் மையம்",
        siteSubtitle: "தமிழ்நாடு அரசு",
        nav: {
            home: "முகப்பு",
            department: "துறை",
            structure: "அலுவலக அமைப்பு",
            role: "DIC பங்கு",
            schemes: "திட்டங்கள்",
            contact: "தொடர்பு",
            adminLogin: "நிர்வாகி உள்நுழைவு",
            logout: "வெளியேறு",
        },
        home: {
            eyebrow: "தமிழ்நாடு அரசு · 1978 முதல்",
            heroTitle: "தமிழ்நாடு முழுவதும் தொழில்முனைவோருக்கு அதிகாரம்",
            heroSubtitle:
                "மாவட்ட தொழில் மையம் என்பது நுண், சிறு மற்றும் நடுத்தர தொழில் நிறுவனங்களுக்கான அரசு திட்டங்கள், மானியங்கள், பயிற்சி மற்றும் வழிகாட்டுதலுக்கான ஒற்றை-சாளர நுழைவாயில் ஆகும்.",
            ctaSchemes: "திட்டங்களைப் பார்",
            ctaContact: "உதவி பெற",
            statsTitle: "ஒரே பார்வையில் தாக்கம்",
            statSchemes: "அரசு திட்டங்கள்",
            statDistricts: "மாவட்டங்கள்",
            statBeneficiaries: "லட்சம் பயனாளிகள்",
            statYears: "சேவை ஆண்டுகள்",
            missionEyebrow: "எங்கள் நோக்கம்",
            missionTitle: "ஒவ்வொரு மாவட்டத்திற்கும் தொழில் வாய்ப்பு",
            missionBody:
                "DIC என்பது தொழில் மற்றும் வர்த்தக ஆணையர் அலுவலகத்தின் நீட்டிக்கப்பட்ட கை. மாநில மற்றும் மத்திய தொழில் கொள்கையை தரையளவில் தொழில் உருவாக்கமாக மாற்றுகிறது. காஞ்சிபுரம் கைவினைஞர் முதல் ஈரோட்டில் உள்ள உணவு பதப்படுத்தும் அலகு வரை — ஒவ்வொரு தொழில்முனைவோருக்கும் இங்கே ஒரு பங்குதாரர் உண்டு.",
            featuredEyebrow: "சிறப்பு திட்டங்கள்",
            featuredTitle: "முதன்மைத் திட்டங்கள்",
            featuredSub: "தொழில்முனைவோருக்கு அதிக பயன் தரும் தேர்ந்தெடுக்கப்பட்ட திட்டங்கள்",
            viewAll: "அனைத்து திட்டங்களையும் பார்க்க",
        },
        department: {
            eyebrow: "துறை பற்றி",
            title: "தமிழ்நாடு மாவட்ட தொழில் மையம்",
            intro:
                "1978-ல் இந்திய அரசின் முயற்சியின் கீழ் நிறுவப்பட்ட மாவட்ட தொழில் மையங்கள் (DICs), மாவட்ட அளவில் MSMEகளை அமைப்பதில் தொழில்முனைவோருக்கு சேவைகள் மற்றும் ஆதரவு வசதிகளை வழங்க உருவாக்கப்பட்டன.",
            visionTitle: "எங்கள் தொலைநோக்கு",
            visionBody:
                "திறமையான, வெளிப்படையான மற்றும் தொழில்முனைவோர் முதல் சூழலியல் மூலம் MSMEகளுக்கு தமிழ்நாட்டை மிகவும் விரும்பப்படும் இடமாக மாற்றுவது.",
            missionTitle: "எங்கள் நோக்கம்",
            missionBody:
                "38 மாவட்டங்களிலும் பொருத்தமான திட்டங்களை அடையாளம் கண்டு, கடன் உதவி, மானிய நிர்வாகம், தொகுப்பு மேம்பாடு, தொழில்நுட்ப வழிகாட்டுதல் மற்றும் சந்தை ஆதரவை வழங்குதல்.",
            objectivesTitle: "முக்கிய நோக்கங்கள்",
            objectives: [
                "தமிழ்நாடு முழுவதும் சமநிலையான பிராந்திய தொழில் வளர்ச்சியை ஊக்குவித்தல்",
                "முதல் தலைமுறை தொழில்முனைவோரை, குறிப்பாக பெண்கள் & SC/ST, அடையாளம் கண்டு வழிகாட்டுதல்",
                "மத்திய & மாநில அரசுகளின் கடன் சார்ந்த மானியத் திட்டங்களை நிர்வகித்தல்",
                "திறன் மேம்பாடு, EDP பயிற்சி மற்றும் தொழில்நுட்ப மேம்படுத்தலை ஏற்படுத்துதல்",
                "MSME கிளஸ்டர்கள், தொழில் தளங்கள் மற்றும் பகிரப்பட்ட உள்கட்டமைப்பை உருவாக்குதல்",
                "வங்கிகள், PSUs மற்றும் துறைகளுடன் ஒற்றை-சாளர தொடர்பாக செயல்படுதல்",
            ],
        },
        structure: {
            eyebrow: "அலுவலக அமைப்பு",
            title: "அமைப்பு படிநிலை",
            subtitle:
                "தமிழ்நாட்டில் உள்ள ஒவ்வொரு DIC-ம் தொழில் மற்றும் வர்த்தக ஆணையர் அலுவலகத்தின் கீழ் இயங்குகிறது, ஒரு பொது மேலாளரால் தலைமை தாங்கப்படுகிறது.",
            roles: {
                commissioner: "தொழில் மற்றும் வர்த்தக ஆணையர்",
                director: "தொழில் மற்றும் வர்த்தக இயக்குநர்",
                gm: "பொது மேலாளர் (DIC)",
                mgr: "மேலாளர்",
                amgr: "உதவி மேலாளர்",
                io: "தொழில் அலுவலர் / புலம் அலுவலர்",
                ta: "தொழில்நுட்ப & அமைச்சரவை பணியாளர்கள்",
            },
        },
        role: {
            eyebrow: "DIC பங்கு",
            title: "மாவட்ட தொழில் மையங்கள் என்ன செய்கின்றன",
            subtitle:
                "யோசனையிலிருந்து தொழில் தளம் ஒதுக்கீடு வரை — முழு அடுக்கு ஆதரவு சூழல்.",
            functionsTitle: "முக்கிய பணிகள்",
            servicesTitle: "தொழில்முனைவோருக்கு வழங்கப்படும் சேவைகள்",
        },
        schemes: {
            eyebrow: "அரசு திட்டங்கள்",
            title: "உங்களுக்கு சரியான திட்டத்தைக் கண்டறியுங்கள்",
            subtitle:
                "மாவட்ட தொழில் மையங்கள் மூலம் நிர்வகிக்கப்படும் மத்திய & மாநில அரசு திட்டங்கள்.",
            searchPlaceholder: "திட்டப் பெயர் அல்லது முக்கிய வார்த்தை மூலம் தேடு…",
            filterAll: "அனைத்து பிரிவுகள்",
            categories: {
                MSME: "MSME",
                Women: "பெண்கள்",
                SC_ST: "SC / ST",
                Youth: "இளைஞர்கள்",
                Agri: "விவசாயம்",
                General: "பொது",
            },
            noResults: "உங்கள் வடிகட்டியுடன் திட்டங்கள் இல்லை.",
            viewDetails: "விவரங்களைப் பார்",
            downloadForm: "விண்ணப்பம் பதிவிறக்கம் (PDF)",
            eligibility: "தகுதி",
            benefits: "பயன்கள்",
            process: "விண்ணப்ப செயல்முறை",
            back: "திட்டங்களுக்கு திரும்பு",
            featured: "சிறப்பு",
        },
        contact: {
            eyebrow: "எங்களை தொடர்பு கொள்ளுங்கள்",
            title: "உங்கள் மாவட்ட தொழில் மையத்தை அணுகுங்கள்",
            subtitle:
                "ஒரு திட்டம் பற்றி கேள்வி உள்ளதா அல்லது தொழில் தொடங்க உதவி தேவையா? விசாரணை அனுப்புங்கள் — மாவட்ட தொழில் அலுவலர் 3 வேலை நாட்களுக்குள் தொடர்பு கொள்வார்.",
            name: "முழு பெயர்",
            email: "மின்னஞ்சல் முகவரி",
            phone: "தொலைபேசி எண்",
            district: "மாவட்டம்",
            subject: "பொருள்",
            message: "உங்கள் செய்தி",
            submit: "விசாரணையை சமர்ப்பி",
            submitting: "சமர்ப்பிக்கிறது…",
            success: "விசாரணை பெறப்பட்டது. விரைவில் தொடர்பு கொள்வோம்.",
            error: "ஏதோ தவறு. மீண்டும் முயற்சிக்கவும்.",
            hqTitle: "தலைமை அலுவலகம்",
            hqAddress:
                "தொழில் மற்றும் வர்த்தக ஆணையர் அலுவலகம், கிண்டி தொழில் தளம், சென்னை — 600 032, தமிழ்நாடு",
            hqPhone: "+91 44 2250 0651",
            hqEmail: "commissioner.dic@tn.gov.in",
            hours: "திங்கள் – வெள்ளி · 10:00 – 17:45 (பொது விடுமுறை நாட்கள் தவிர)",
        },
        admin: {
            loginTitle: "நிர்வாகி உள்நுழைவு",
            loginSub: "DIC உள்ளடக்க மேலாண்மை பலகத்தை அணுகவும்.",
            email: "மின்னஞ்சல்",
            password: "கடவுச்சொல்",
            signIn: "உள்நுழை",
            signingIn: "உள்நுழைகிறது…",
            loginFailed: "தவறான விவரங்கள்.",
            dashTitle: "நிர்வாகி பலகை",
            welcome: "வரவேற்பு",
            tabSchemes: "திட்டங்களை நிர்வகி",
            tabEnquiries: "விசாரணைகள்",
            newScheme: "புதிய திட்டம்",
            editScheme: "திட்டத்தை திருத்து",
            deleteScheme: "நீக்கு",
            save: "சேமி",
            saving: "சேமிக்கிறது…",
            cancel: "ரத்து",
            confirmDelete: "இந்த திட்டத்தை நீக்க வேண்டுமா?",
            markHandled: "செய்யப்பட்டது என குறி",
            markNew: "புதியது என குறி",
            deleteEnquiry: "நீக்கு",
            statusNew: "புதிய",
            statusHandled: "செய்யப்பட்டது",
            noEnquiries: "இதுவரை விசாரணைகள் இல்லை.",
        },
        footer: {
            about:
                "மாவட்ட தொழில் மையம் என்பது தமிழ்நாடு அரசின் தொழில் மற்றும் வர்த்தக ஆணையர் அலுவலகத்தின் நீட்டிக்கப்பட்ட கை. அனைத்து 38 மாவட்டங்களிலும் MSME வளர்ச்சியை ஊக்குவிக்கிறது.",
            quickLinks: "விரைவு இணைப்புகள்",
            contact: "தொடர்பு",
            copyright: "© {year} மாவட்ட தொழில் மையம், தமிழ்நாடு அரசு. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
            disclaimer:
                "இது ஒரு மாதிரி திட்டமாக உருவாக்கப்பட்ட ஆர்ப்பாட்ட வலைத்தளம். உள்ளடக்கம் விளக்கமளிக்கும் நோக்கத்திற்கானது, தமிழ்நாடு அரசின் அதிகாரப்பூர்வ வெளியீடு அல்ல.",
        },
    },
};

export const FUNCTIONS_EN = [
    "Identify entrepreneurs and suitable industrial projects",
    "Provide credit facilitation and bank linkage for MSMEs",
    "Administer PMEGP, UYEGP, NEEDS, TAHDCO, Mudra and other schemes",
    "Coordinate Entrepreneurship Development Programmes (EDP)",
    "Facilitate industrial estate & land allotment",
    "Support cluster development and Common Facility Centres",
    "Promote SC/ST, Women & rural entrepreneurship",
    "Liaise with banks, PSUs, universities and industry bodies",
];

export const FUNCTIONS_TA = [
    "தொழில்முனைவோர் மற்றும் பொருத்தமான தொழில் திட்டங்களை அடையாளம் காண்பது",
    "MSMEகளுக்கு கடன் உதவி மற்றும் வங்கி இணைப்பு வழங்குதல்",
    "PMEGP, UYEGP, NEEDS, TAHDCO, முத்ரா போன்ற திட்டங்களை நிர்வகித்தல்",
    "தொழில்முனைவோர் மேம்பாட்டு நிகழ்ச்சி (EDP) ஒருங்கிணைப்பு",
    "தொழில் தளம் & நில ஒதுக்கீட்டை எளிதாக்குதல்",
    "கிளஸ்டர் மேம்பாடு மற்றும் பொது வசதி மையங்களை ஆதரித்தல்",
    "SC/ST, பெண்கள் மற்றும் கிராமப்புற தொழில் ஊக்குவிப்பு",
    "வங்கிகள், PSUs, பல்கலைக்கழகங்கள் மற்றும் தொழில் அமைப்புகளுடன் தொடர்பு",
];

export const SERVICES_EN = [
    { title: "Project Identification", body: "Guidance on choosing viable projects based on district resources and market." },
    { title: "Techno-Economic Feasibility", body: "Preparation of Detailed Project Reports (DPRs) with cost, machinery and market analysis." },
    { title: "Registration & Licensing", body: "Udyam, GST, factory licences and pollution NOC — a single-window process." },
    { title: "Credit Facilitation", body: "Bank linkage & subsidy processing under Central/State schemes." },
    { title: "EDP Training", body: "Free entrepreneurship & skill training in partnership with EDII, MSME-DFO, MSME-DI." },
    { title: "Marketing Support", body: "Exhibitions, trade fairs, Government e-Marketplace (GeM) onboarding." },
];

export const SERVICES_TA = [
    { title: "திட்ட அடையாளம்", body: "மாவட்ட வளங்கள் மற்றும் சந்தை அடிப்படையில் சாத்தியமான திட்டங்களைத் தேர்ந்தெடுக்க வழிகாட்டுதல்." },
    { title: "தொழில்நுட்ப-பொருளாதார சாத்தியம்", body: "செலவு, இயந்திரம் மற்றும் சந்தை பகுப்பாய்வுடன் விரிவான திட்ட அறிக்கை (DPR)." },
    { title: "பதிவு & உரிமம்", body: "உத்யம், GST, தொழிற்சாலை உரிமம் மற்றும் மாசுக் கட்டுப்பாடு NOC — ஒற்றை சாளர செயல்முறை." },
    { title: "கடன் உதவி", body: "மத்திய/மாநில திட்டங்களின் கீழ் வங்கி இணைப்பு & மானிய செயலாக்கம்." },
    { title: "EDP பயிற்சி", body: "EDII, MSME-DFO உடன் இணைந்து இலவச தொழில்முனைவோர் மற்றும் திறன் பயிற்சி." },
    { title: "சந்தை ஆதரவு", body: "கண்காட்சிகள், வர்த்தக நிகழ்வுகள், அரசு இ-சந்தை (GeM) இணைப்பு." },
];
